import { translate } from '../../../i18n/I18nProvider';
import { LANGUAGES } from '../../../consts/initialValues';
import DefaultDetailRow from './DefaultDetailRow';

const TelepoUserDetails = ({ item, classes }) => {
  const { product_offering = {} } = item || {};
  return (
    <div style={{ paddingLeft: 20, marginTop: 4 }}>
      <DefaultDetailRow
        label={translate('FIRST_NAME')}
        value={product_offering?.first_name || ''}
        classes={classes}
      />
      <DefaultDetailRow
        label={translate('LAST_NAME')}
        value={product_offering?.last_name || ''}
        classes={classes}
      />
      <DefaultDetailRow
        label={translate('TABLE.USERNAME')}
        value={product_offering?.username || ''}
        classes={classes}
      />
      <DefaultDetailRow
        label={translate('EMAIL')}
        value={product_offering?.email || ''}
        classes={classes}
      />
      <DefaultDetailRow
        label={translate('LANGUAGE')}
        value={
          LANGUAGES[product_offering?.language]
            ? translate(LANGUAGES[product_offering.language])
            : product_offering?.language || ''
        }
        classes={classes}
      />
    </div>
  );
};

export default TelepoUserDetails;
